import { render, staticRenderFns } from "./PaginaStoricoSoggetto.vue?vue&type=template&id=db28f7bc"
import script from "./PaginaStoricoSoggetto.vue?vue&type=script&lang=js"
export * from "./PaginaStoricoSoggetto.vue?vue&type=script&lang=js"
import style0 from "./PaginaStoricoSoggetto.vue?vue&type=style&index=0&id=db28f7bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports